<template>
<div v-if="visible" class="excel-viewer-backdrop" @click.self="close">
    <div class="excel-viewer" id="xls-report-viewer">
        <div class="toolbar">
            <button class="button is-danger" @click="close">закрыть</button>
        </div>
        <div v-if="isLoading" class="loadingSpinner" style="position:absolute;
            display: flex;
            justify-content: center;
            flex-flow: column;
            align-items: center;            
            width: 100%;
            height: 90%;">
            <i  class="fas fa-spinner fa-spin" style="font-size: 5rem; color: green;"></i>
            подготовка отчёта
        </div>
        <iframe :srcdoc="srcdoc" :src="url" frameborder='0' scrolling="no" />
    </div>

</div>    

</template>

<script>
//sandbox="allow-pointer-lock allow-popups allow-same-origin allow-scripts allow-forms allow-top-navigation" 
const sheetApiRoot = 'https://sheets.googleapis.com/v4/spreadsheets/';
export default {
    name: 'excelViewer',
    template: '#excel-viewer',
    params:['url'],
    data (){
        return{            
            visible: false,
            url: null,
            srcdoc: null,
            isLoadin: true,
            isLoading: false,
        } 
    },

    
    methods:{
        show(){
            this.visible = true;
        },
//&wdFCCState=0&wdMobileHost=3&nocache=true  
        requestViewer(reportPath, reportFile){
            const self = this;
            //const mtime = new Date().getTime();
            //const key = mtime;
            //let path = reportPath + '?file=' + key + '___' + reportFile;
            let url = 'http://xlsgen.ddns.net/api/curl.php?file='+reportFile;
            this.$axios.get(url).then(
                function(response){
                    self.srcdoc=response.data;
                }
            );
        },

        setUrl(reportPath, reportFile){
            const mtime = new Date().getTime();
            const key = mtime;
            //let path = reportPath + '&key=' + key;
            //let path = reportPath + '?key=' + key + '&file=' + reportFile;
            let path = reportPath + '?file=' + key + '___' + reportFile;
            this.url = 
                'https://view.officeapps.live.com/op/view.aspx?src=' + path + '&wdAllowInteractivity=True&AllowTyping=True&wdHideGridlines=True&wdHideHeaders=True&wdhideheaders=true&ActiveCell=A1'
        },
        close(){
            this.url = '';
            isLoadin: false,
            this.visible = false;
        },             

    },
    
    created(){          
    },

    mounted(){                       
    }
    
}
</script>




<style>
.dashboard-view{    flex-grow: 1;}
.excel-viewer-backdrop{
    position: absolute;
    display: flex;
    align-content: center;
    height: 100vh;
    top:0;
    left:0;
    width: 100%;
    padding-top: 20px;
    padding-bottom: 20px;
    padding-left: 20px;
    padding-right: 20px;
    background: rgba(0,0,0, 0.5);
    backdrop-filter: blur(12);
    z-index: 1000;
}
.excel-viewer{
    border: 1px solid #ccc;
    border-radius: 3px;
    display: flex;
    flex-flow: column;
    flex-grow: 1;
    flex-shrink: 1;
    width: 100%;
    height: 100%;
    background: #fff;
    overflow: hidden;
    position: relative;
}

.excel-viewer .toolbar{
 position: absolute;
 padding: 4px;
 /* width: 100%; */
 background: #fff;
 /* transform: translateX(-50%); */
 display: flex;
 /* justify-content: center; */
 justify-content: flex-end;
}

.excel-viewer iframe{
    flex-grow: 1;
    flex-shrink: 1;
    border: 0px 0px 0px 0px;
    overflow: hidden;
    
    /* только если фрейм открыт в режиме "op/view.aspx?"  при "embed.aspx?" верхней части нет */
     margin-top: -51px; 

}
</style>
